
import Language from 'services/Language.js';
import utils from 'services/utils';

let isScriptGeneratedDynamically = false;
let isFailedToLoadScript = false;

// const GOOGLE_RECAPTCHA_TEMPLATE = "<script id='grecaptcha-s' src='https://www.google.com/recaptcha/api.js?render=${htmlKey}'></script>";

export default {
    errorCallback: null,
    showMessage(text_sign, type) {
        if (window.$$noticeMessage && window.$$noticeMessage.show) {
            Language.onLoad(() => {
                window.$$noticeMessage.show(Language.getLabel(text_sign), type);
            });
        }
        if ((!window.$$noticeMessage || !window.$$noticeMessage.show)
                && (utils.app_noty)) {
            Language.onLoad(() => {
                utils.app_noty({
                    type,
                    text: Language.getLabel(text_sign),
                });
            });
        }

    },
    executeError(langKey, type) {
        this.showMessage(langKey, type);
        this.errorCallback && this.errorCallback(langKey);
    },
    afterScriptLoad(htmlKey, callback) {
        const that = this;
        let script;
        if ($('body #grecaptcha-s').length) {
            script = $('body #grecaptcha-s').get(0);
            if (!!$(script).attr('data-load-finished') || !isScriptGeneratedDynamically) {
                callback();
                return;
            }
        }
        if (!script) {
            script = document.createElement('script');
            script.src = 'https://www.google.com/recaptcha/api.js?render=${htmlKey}'.replace('${htmlKey}', htmlKey);
            script.id = 'grecaptcha-s';
            isScriptGeneratedDynamically = true;
            document.body.appendChild(script);
        }

        script.onload = function() {
            $(script).attr('data-load-finished', true);
            callback();
        };
        script.onerror = function() {
            isFailedToLoadScript = true;
            isScriptGeneratedDynamically = false;
            $(script).remove();
            that.executeError('L_FAILED_TO_LOAD_CAPTCHA', 'error');
        };
        /*
        newScript.on('load', () => {
            callback();
        });
        newScript.on('error', () => {
            this.executeError('L_FAILED_TO_LOAD_CAPTCHA', 'error');
        });
        */
    },
    execute(action, htmlKey, callback, errorCallback) {
        const that = this;
        this.errorCallback = errorCallback;
        this.afterScriptLoad(htmlKey, () => {
            let ERROR_TIMEOUT = 10 * 1000;
            let isCaptchaLoadFinished = false;
            if (!window.grecaptcha) {
                isCaptchaLoadFinished = true;
                that.executeError('L_FAILED_TO_LOAD_CAPTCHA', 'error');
                // this.showMessage();
                return;
            }
            setTimeout(() => {
                if (!isCaptchaLoadFinished) {
                    that.showMessage('L_CAPTCHA_SERVICE_ISNT_RESPONDING');
                }
                setTimeout(() => {
                    if (!isCaptchaLoadFinished) {
                        that.executeError('L_FAILED_TO_RECEIVE_CAPTCHA_INFO', 'error');
                    }
                }, 5 * ERROR_TIMEOUT);
            }, ERROR_TIMEOUT);
            grecaptcha.ready(function() {
                try {
                    grecaptcha.execute(htmlKey, {action: action})
                        .then(function (token) {
                            if (!token) {
                                isCaptchaLoadFinished = true;
                                that.executeError('L_FAILED_TO_RECEIVE_CAPTCHA_INFO', 'error');
                                return;
                            }
                            isCaptchaLoadFinished = true;
                            callback(token);
                        })/*.catch((error) => {
                               isCaptchaLoadFinished = true;
                               showMessage('L_FAILED_TO_RECEIVE_CAPTCHA_INFO', 'error');
                           });*/
                } catch (error) {
                    isCaptchaLoadFinished = true;
                    that.executeError('L_FAILED_TO_RECEIVE_CAPTCHA_INFO', 'error');
                }
            });
        });
    }
};
